import React from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../../styles/SidebarNav.scss";

const TeacherSidebarMenu = ({ state, dispatch }) => {
    const { gradingProfiles, navCollapsed, selectedLink } = state;
    const navigate = useNavigate();

    const handleOnClick = (linkName) => {
        const labelArray = linkName.split("/").map((str) => ({ label: str, path: `/${str}` }));
        dispatch({ type: "SET_SELECTED_LINK", payload: linkName });
        dispatch({
            type: "SET_LABEL_OBJ",
            payload: linkName === "HOME" ? [{ label: "Home", path: "/home" }] : labelArray
        });
        navigate(`/${linkName.split(" ")[0].toLowerCase()}`);
    };

    return !navCollapsed ? (
        <div className="expanded-nav-container">
            <div
                className="expanded-nav-arrow-row"
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        dispatch({ type: "TOGGLE_NAV" });
                    }
                }}
                onClick={() => dispatch({ type: "TOGGLE_NAV" })}
                role="button"
                tabIndex={0}
            >
                <i className="bi bi-arrow-bar-left white arrow-icon"></i>
            </div>
            <div
                className={`expanded-nav-row ${selectedLink === "HOME" ? "selected-row" : "not-selected-row"}`}
                onClick={() => handleOnClick("HOME")}
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        handleOnClick("HOME");
                    }
                }}
                role="button"
                tabIndex={0}
            >
                <i className={`bi bi-house-fill ${selectedLink === "HOME" ? "dk-blue" : "white"}`}></i>
                <span className={`expanded-nav-link ${selectedLink === "HOME" ? "dk-blue" : "white"}`}>Home</span>
            </div>
            <div
                className={`expanded-nav-row ${selectedLink === "HOME/SUMMARY" ? "selected-row" : "not-selected-row"}`}
                onClick={() => handleOnClick("HOME/SUMMARY")}
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        handleOnClick("HOME/SUMMARY");
                    }
                }}
                role="button"
                tabIndex={0}
            >
                <i className={`bi bi-card-checklist ${selectedLink === "HOME/SUMMARY" ? "dk-blue" : "white"}`}></i>
                <span className={`expanded-nav-link ${selectedLink === "HOME/SUMMARY" ? "dk-blue" : "white"}`}>
                    EPR Summary
                </span>
            </div>
            {gradingProfiles && gradingProfiles.length > 0 && selectedLink.includes("HOME/SUMMARY") && (
                <div>
                    <div
                        className={`expanded-nav-sub-row ${selectedLink.includes("HOME/SUMMARY/ROSTER") ? "selected-row" : "not-selected-row"}`}
                        onClick={() => handleOnClick("HOME/SUMMARY/ROSTER")}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                handleOnClick("HOME/SUMMARY/ROSTER");
                            }
                        }}
                        role="button"
                        tabIndex={0}
                    >
                        <i
                            className={`bi bi-people-fill ${selectedLink.includes("HOME/SUMMARY/ROSTER") ? "dk-blue" : "white"}`}
                        ></i>
                        <span
                            className={`expanded-nav-link ${selectedLink.includes("HOME/SUMMARY/ROSTER") ? "dk-blue" : "white"}`}
                        >
                            EPR Roster
                        </span>
                    </div>
                    <div
                        className={`expanded-nav-sub-row ${selectedLink.includes("HOME/SUMMARY/SHARE") ? "selected-row" : "not-selected-row"}`}
                        onClick={() => handleOnClick("HOME/SUMMARY/SHARE")}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                handleOnClick("HOME/SUMMARY/SHARE");
                            }
                        }}
                        role="button"
                        tabIndex={0}
                    >
                        <i
                            className={`bi bi-box-arrow-up-right ${selectedLink.includes("HOME/SUMMARY/SHARE") ? "dk-blue" : "white"}`}
                        ></i>
                        <span
                            className={`expanded-nav-link ${selectedLink.includes("HOME/SUMMARY/SHARE") ? "dk-blue" : "white"}`}
                        >
                            Manage Shares
                        </span>
                    </div>
                    <div>
                        <div
                            className={`expanded-nav-sub-row ${selectedLink.includes("HOME/SUMMARY/INPUT-RATINGS") ? "selected-row" : "not-selected-row"}`}
                            onClick={() => handleOnClick("HOME/SUMMARY/INPUT-RATINGS")}
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    handleOnClick("HOME/SUMMARY/INPUT-RATINGS");
                                }
                            }}
                            role="button"
                            tabIndex={0}
                        >
                            <i
                                className={`bi bi-table ${selectedLink.includes("HOME/SUMMARY/INPUT-RATINGS") ? "dk-blue" : "white"}`}
                            ></i>
                            <span
                                className={`expanded-nav-link ${selectedLink.includes("HOME/SUMMARY/INPUT-RATINGS") ? "dk-blue" : "white"}`}
                            >
                                Input Ratings
                            </span>
                        </div>

                        {selectedLink.includes("HOME/SUMMARY/INPUT-RATINGS") && (
                            <>
                                <div
                                    className={`expanded-nav-sub-sub-row ${selectedLink === "HOME/SUMMARY/INPUT-RATINGS/HOMEROOM" ? "selected-row" : "not-selected-row"}`}
                                    onClick={() => handleOnClick("HOME/SUMMARY/INPUT-RATINGS/HOMEROOM")}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                            handleOnClick("HOME/SUMMARY/INPUT-RATINGS/HOMEROOM");
                                        }
                                    }}
                                    role="button"
                                    tabIndex={0}
                                >
                                    <i
                                        className={`bi bi-circle-fill tiny-icon ${selectedLink.includes("HOME/SUMMARY/INPUT-RATINGS/HOMEROOM") ? "dk-blue" : "white"}`}
                                    ></i>
                                    <span
                                        className={`expanded-nav-link ${selectedLink === "HOME/SUMMARY/INPUT-RATINGS/HOMEROOM" ? "dk-blue" : "white"}`}
                                    >
                                        Homeroom
                                    </span>
                                </div>
                                <div
                                    className={`expanded-nav-sub-sub-row ${selectedLink === "HOME/SUMMARY/INPUT-RATINGS/GROUPS" ? "selected-row" : "not-selected-row"}`}
                                    onClick={() => handleOnClick("HOME/SUMMARY/INPUT-RATINGS/GROUPS")}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                            handleOnClick("HOME/SUMMARY/INPUT-RATINGS/GROUPS");
                                        }
                                    }}
                                    role="button"
                                    tabIndex={0}
                                >
                                    <i
                                        className={`bi bi-circle-fill tiny-icon ${selectedLink.includes("HOME/SUMMARY/INPUT-RATINGS/GROUPS") ? "dk-blue" : "white"}`}
                                    ></i>
                                    <span
                                        className={`expanded-nav-link ${selectedLink === "HOME/SUMMARY/INPUT-RATINGS/GROUPS" ? "dk-blue" : "white"}`}
                                    >
                                        Groups
                                    </span>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            )}
        </div>
    ) : (
        <div className="collapsed-nav-container">
            <div
                className="collapsed-nav-row"
                onClick={() => dispatch({ type: "TOGGLE_NAV" })}
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        dispatch({ type: "TOGGLE_NAV" });
                    }
                }}
                role="button"
                tabIndex={0}
            >
                <i className={`bi bi-arrow-bar-right white arrow-icon`}></i>
            </div>
            <div
                className={`collapsed-nav-row ${selectedLink === "HOME" ? "selected-row" : "not-selected-row"}`}
                onClick={() => handleOnClick("HOME")}
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        handleOnClick("HOME");
                    }
                }}
                role="button"
                tabIndex={0}
            >
                <i className={`bi bi-house-fill ${selectedLink === "HOME" ? "dk-blue" : "white"}`}></i>
            </div>
            <div>
                <div
                    className={`collapsed-nav-row ${selectedLink === "HOME/SUMMARY" ? "selected-row" : selectedLink.includes("HOME/SUMMARY/ROSTER") || selectedLink.includes("SHARE") || selectedLink.includes("INPUT-RATINGS") ? "child-selected" : "not-selected-row"}`}
                    onClick={() => handleOnClick("HOME/SUMMARY")}
                    onKeyDown={(e) => {
                        if (e.key === "Enter") handleOnClick("HOME/SUMMARY");
                    }}
                    role="button"
                    tabIndex={0}
                >
                    <i className={`bi bi-card-checklist ${selectedLink === "HOME/SUMMARY" ? "dk-blue" : "white"}`}></i>
                </div>

                {selectedLink.includes("HOME/SUMMARY") && (
                    <>
                        <div
                            className={`collapsed-sub-nav-row ${selectedLink.includes("HOME/SUMMARY/ROSTER") ? "selected-row" : "not-selected-row"}`}
                            onClick={() => handleOnClick("HOME/SUMMARY/ROSTER")}
                            role="button"
                            tabIndex={0}
                        >
                            <i
                                className={`bi bi-people small-icon ${selectedLink.includes("HOME/SUMMARY/ROSTER") ? "dk-blue" : "white"}`}
                                title="Roster"
                            ></i>
                        </div>
                        <div
                            className={`collapsed-sub-nav-row ${selectedLink.includes("HOME/SUMMARY/SHARE") ? "selected-row" : "not-selected-row"}`}
                            onClick={() => handleOnClick("HOME/SUMMARY/SHARE")}
                            role="button"
                            tabIndex={0}
                        >
                            <i
                                className={`bi bi-box-arrow-up-right small-icon ${selectedLink.includes("HOME/SUMMARY/SHARE") ? "dk-blue" : "white"}`}
                                title="Manage Shares"
                            ></i>
                        </div>
                        <div
                            className={`collapsed-sub-nav-row ${selectedLink.includes("HOME/SUMMARY/INPUT-RATINGS") ? "selected-row" : "not-selected-row"}`}
                            onClick={() => handleOnClick("HOME/SUMMARY/INPUT-RATINGS")}
                            role="button"
                            tabIndex={0}
                        >
                            <i
                                className={`bi bi-table small-icon ${selectedLink.includes("HOME/SUMMARY/INPUT-RATINGS") ? "dk-blue" : "white"}`}
                                title="Input Ratings"
                            ></i>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

TeacherSidebarMenu.propTypes = {
    state: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired
};

export default TeacherSidebarMenu;
